import { MessageType } from "../enums/MessageType";
import { AppCategory } from "../enums/AppCategories";

export class RefreshToken {
    all: boolean;
    target: any;
    code: string;
    messageType: MessageType;
    appCategory: AppCategory;
    customerId: any;
    locationId: any;
    dqoiIndex: number;
    id: any;
}
